import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { useAppState, HistoryElement, AutocompleteElement, Keywords, useCurrencyFormatting, useResponse } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"
import { useEffect, useState } from "preact/hooks";
import Icon from "./elements/Icon"




export default function History() {
    // const { historyItems } = useAppState()
    const [isLoad, setIsLoad] = useState(false);
    const [query, setQuery] = useState("Dresses");
    const [products, setProducts] = useState();
    const [keywords, setkeywords] = useState();
    const [search, setSearch] = useState();
    const { format } = useCurrencyFormatting()

    
    const hits = [
        {
            keyword: "Dresses"
        },
        {
            keyword: "Rompers"
        },
        {
            keyword: "Skirts"
        },
        {
            keyword: "Cardigans"
        },
        {
            keyword: "Denim"
        },
    ]

    useEffect(() => {
        nostojs(api => {
            api.search({
                query: query,
                products: {
                    size: 6,
                    fields: [
                        "productId",
                        "url",
                        "categories",
                        "name",
                        "tags1",
                        "alternateImageUrls",
                        "imageUrl",
                        "thumbUrl",
                        "brand",
                        "availability",
                        "price",
                        "priceText",
                        "listPrice",
                        "ratingValue",
                        "reviewCount",
                        "available",
                        "skus.id",
                        "customFields.key",
                        "customFields.value"
                    ]
                },
                keywords: {
                    fields: ["keyword", "_highlight.keyword"],
                    facets: ["*"]
                }
            }).then(response => {

                response.keywords.hits = hits

                setProducts(response.products)
                setkeywords(response.keywords)
                setSearch(response)
            }).catch(error => {
                console.error('Error:', error);
            });
        });
    }, [query]);

    useEffect(() => {
        const elements = document.querySelectorAll(".ns-autocomplete-keywords .ns-autocomplete-element");
        const element = document.querySelector(".ns-autocomplete-keywords .ns-autocomplete-element");
        
        if(!isLoad && element) {
            element.classList.add('active')
            setIsLoad(true)
        }
        
        elements.forEach((element) => {
            element.addEventListener("mouseenter", handleHover);
        });

        return () => {
            elements.forEach((element) => {
                element.removeEventListener("mouseenter", handleHover);
            });
        };
    }, [products, keywords]);

    const handleHover = (e) => {
        const elementValue = e.target.getAttribute("data-nosto-query");
        const elements = document.querySelectorAll(".ns-autocomplete-keywords .ns-autocomplete-element");
        elements.forEach(el => el.classList.remove('active'))

        if (elementValue) {
            e.target.classList.add('active')
            setQuery(elementValue);
        }
    };

    if (!products?.hits?.length && !keywords?.hits?.length) {
        return
    }

    return (
        <div
            class="ns-autocomplete pd-autocomplete-history ns-absolute ns-d-flex ns-flex-column ns-flex-md-row ns-align-items-start ns-background-white ns-border-box pd-autocomplete"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100 ns-mt-sm-auto">
                <div class="ns-d-flex ns-flex-column ns-flex-md-row">
                    {keywords?.hits?.length > 0 && (
                        <div
                            class={`ns-autocomplete-keywords ns-d-flex ns-flex-column ns-col-12 pd-autocomplete-keywords ${products?.hits?.length > 0 ? "ns-col-sm-12 ns-col-md-3" : "ns-col-sm-12"
                                }`}
                        >
                            <div class="ns-color-black ns-py-2 ns-px-4 ns-mt-5 ns-mt-md-1 pd-history-title">
                                Top Searches
                            </div>
                            <div class="ns-d-flex ns-flex-sm-column ns-flex-row ns-flex-wrap">
                                <Keywords
                                    hits={keywords.hits}
                                    keywordComponent={Keyword}
                                    elementComponent={Element}
                                    keywordInCategoryComponent={KeywordInCategory}
                                    onMouseEnter={() => handleHover(hit.keyword)}
                                />
                            </div>
                        </div>
                    )}
                    {products?.hits?.length > 0 && (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="ns-color-black-alt ns-py-2 pd-text-uppercase ns-px-4 ns-mx-auto ns-font-medium ns-font-4 desktop-only pd-autocomplete-products-title">
                                Product Suggestions
                            </div>
                            <div class="ns-d-flex ns-flex-wrap ns-p-5">
                                {products?.hits?.map(hit => {
                                    return (
                                        <AutocompleteElement class="pd-autocomplete-element" hit={hit}>
                                            <div
                                                data-url={hit.url}
                                                class="ns-d-flex ns-flex-column ns-clickable ns-p-2"
                                                data-nosto-element="product"
                                            >
                                                <img
                                                    class="ns-h-auto ns-object-contain ns-mx-auto"
                                                    src={hit.imageUrl ?? productImagePlaceholder}
                                                    alt={hit.name}
                                                    width="100"
                                                    height="80"
                                                />
                                                <div class="">
                                                    {/* {hit.brand && (
                                                        <div class="ns-color-black ns-mb-1 ns-font-4">{hit.brand}</div>
                                                    )} */}
                                                    <div class="ns-my-1 ns-font-4 ns-clipped ns-text-four-lines pd-autocomplete-title">
                                                        {hit.name}
                                                    </div>
                                                    <div class="pd-autocomplete-price">
                                                        <span class={hit.listPrice && hit.listPrice > hit.price && "ns-color-black"}>{format(hit.price)}</span>
                                                        {hit.listPrice && hit.listPrice > hit.price && (
                                                            <span class="ns-color-black ns-font-4 ns-text-striked ns-ml-2 pd-autocomplete-price-compare">
                                                                {format(hit.listPrice)}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </AutocompleteElement>
                                    )
                                })}
                            </div>

                            <SubmitButton text={`See ${products.total} results for "${search.query}"`} url={`/search?q=${search.query}`} />

                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}


function SubmitButton({ className, text, url }) {
    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-center ns-p-3 pd-autocomplete-submit ${className}`}>
            <a href={url} className="ns-act-btn pd-text-uppercase ns-font-5 ns-text-align-right ns-w-100 pd-autocomplete-more-results ns-font-thin ns-color-black-alt">
                {text}
                <Icon name="arrow-right" className="ns-ml-2" />
            </a>
        </div>
    )
}

function Keyword({ hit }) {
    return (
        <span data-nosto-element="keyword">
            {hit.keyword}
        </span>
    )
}

function Element({ hit, keywordComponent, filter }) {
    return (
        <AutocompleteElement hit={hit} filter={filter} class="ns-clickable ns-py-2 ns-px-5 ns-font-4">
            {keywordComponent}
        </AutocompleteElement>
    )
}

function KeywordInCategory({ category, children }) {
    return (
        <span class="ns-clickable">
            {category?.value ? (
                <span>
                    {children}{" "}
                    <span class="ns-keyword-in-category">
                        in <span>{category.value}</span>
                    </span>
                </span>
            ) : (
                children
            )}
        </span>
    )
}